// Where the auth state sends the current screen. Pure so it can be unit-tested
// (scripts/test-auth-required-redirect.cjs). Runs on every route change once the user has loaded.

export const SIGNED_OUT_PROTECTED_ROUTES = ['Profile', 'MyReports', 'Admin', 'AddVenue'];

// Linking stringifies params, so a reloaded /login carries returnParams as "[object Object]".
const isPlainObject = (v) => !!v && typeof v === 'object' && !Array.isArray(v);

// Returns { method, name, params } to dispatch, or null to stay put.
// canGoBack: whether the stack has a screen under the current one.
export function decideAuthRedirect(route, user, { canGoBack = false } = {}) {
  const name = route?.name;
  if (!name) return null;

  if (!user) {
    // Guests stay on public pages; requireAuth screens send them to Login themselves.
    return SIGNED_OUT_PROTECTED_ROUTES.includes(name) ? { method: 'navigate', name: 'Home' } : null;
  }

  const hasAccess = user.userType === 'admin' || user.status === 'active';
  if (!hasAccess) {
    // Suspended, pending or unknown status: Waitlist, wherever they try to go (Back included).
    return name === 'Waitlist' ? null : { method: 'navigate', name: 'Waitlist' };
  }

  if (name === 'Login') {
    const returnTo = route.params?.returnTo;
    if (returnTo && returnTo !== 'Login') {
      // Opened on top of the page it returns to (MapAccessPrompt): Login's own goBack handles it.
      if (route.params?.returnBack && canGoBack) return null;
      const returnParams = route.params?.returnParams;
      return { method: 'replace', name: returnTo, params: isPlainObject(returnParams) ? returnParams : undefined };
    }
    return { method: 'navigate', name: 'Home' };
  }
  if (name === 'Waitlist') return { method: 'navigate', name: 'Home' };
  return null;
}
